import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9b95c22c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b95c22c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b95c22c')) {
      api.createRecord('9b95c22c', component.options)
    } else {
      api.reload('9b95c22c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9b95c22c&scoped=true", function () {
      api.rerender('9b95c22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/functionModule/interfaceuser/components/viewToken/index.vue"
export default component.exports